export interface Author {
  id: string
  name: string
  slug: string
  bio: string
  shortBio: string
  avatar: string
  credentials: string
  linkedIn?: string
  website?: string
}

export const authors: Author[] = [
  {
    id: 'holicosy',
    name: 'Holicosy',
    slug: 'holicosy',
    bio: 'Holicosy est la plateforme française dédiée aux chambres d\'hôtes authentiques. Notre mission : connecter les voyageurs en quête d\'expériences uniques avec des propriétaires passionnés, partout en France. Forts de notre expertise du marché des hébergements chez l\'habitant, nous partageons régulièrement nos conseils, guides et coups de cœur pour vous aider à découvrir les plus belles chambres d\'hôtes de l\'Hexagone. Que vous soyez voyageur à la recherche d\'un séjour inoubliable ou propriétaire souhaitant valoriser votre établissement, nos articles sont conçus pour vous accompagner.',
    shortBio: 'Plateforme française de chambres d\'hôtes',
    avatar: '/images/authors/holicosy-avatar.webp',
    credentials: 'Plateforme spécialisée chambres d\'hôtes en France',
    website: 'https://holicosy.fr',
  },
]

export function getAuthorById(id: string): Author | undefined {
  return authors.find(a => a.id === id)
}

export function getAuthorBySlug(slug: string): Author | undefined {
  return authors.find(a => a.slug === slug)
}
